export default { HEADER: 1, MODAL_BACKGROUND: 1000, SESSION_MODAL_BACKGROUND: 1100 };
